<template>
  <div class="ips-login__content self">
    <div>
      <p class="system_name mgt-0">一爱智慧服务平台</p>

      <div class="login_container"  element-loading-background="rgba(0, 0, 0, 0.2)" v-loading="loading">
        <form class="mgt-40" onsubmit="return false">
          <div>
            <div class="login_panel">
              <div class="login_title">
                <span>联盟登录</span>

                <a class="pull-right fs-16 pointer mgt-12 login_toggle" href="./login.html">系统登录</a>
              </div>

              <div class="mgt-33 form_item_container">
                <el-input
                  placeholder="输入用户名"
                  v-model="formObject.username"
                  class="username"
                  ref="username"
                  clearable
                >
                  <i slot="prefix" class="el-input__icon el-icon-user-solid form_item_icon"/>

                  <el-select v-model="alliance" slot="append" placeholder="请选择">
                    <el-option
                      :label="s.label"
                      :value="s.value"
                      v-for="s in suffixs"
                      :key="s.value"
                    />
                  </el-select>
                </el-input>
              </div>

              <div class="mgt-30 form_item_container">
                <el-input
                  placeholder="输入密码"
                  type="password"
                  v-model="formObject.password"
                  class="password"
                  clearable
                >
                  <i slot="prefix" class="el-input__icon el-icon-lock form_item_icon"/>
                </el-input>
              </div>

              <!-- 该功能保留 -->
              <!-- <div class="mgt-30">
                    <el-checkbox v-model="remenber" label="记住用户名和密码" border></el-checkbox>
              </div>-->
              <!-- 该功能保留 -->

              <div class="mgt-30 form_item_container">
                <button
                  class="el-button login_btn el-button--primary"
                  type="submit"
                  @click="login"
                >登 录</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import {LOGIN2} from "@/store/mutation-types";

  export default {
  data() {
    return {
      loading: false,
      formObject: {
        username: "",
        password: ""
      },
      alliance: "@cloud.justbon.com",
      suffixs: [
        { label: "@cloud.justbon.com", value: "@cloud.justbon.com" },
        { label: "@jgxc.justbon.com", value: "@jgxc.justbon.com" },
        { label: "@mdwy.justbon.com", value: "@mdwy.justbon.com" },
        { label: "@hywy1.justbon.com", value: "@hywy1.justbon.com" },
        { label: "@tblxc.justbon.com", value: "@tblxc.justbon.com" },
        { label: "@xnzh.justbon.com", value: "@xnzh.justbon.com" },
        { label: "@xcj.justbon.com", value: "@xcj.justbon.com" },
        { label: "@ycwy.justbon.com", value: "@ycwy.justbon.com" },
        { label: "@czjt.justbon.com", value: "@czjt.justbon.com" },
        { label: "@wawy.justbon.com", value: "@wawy.justbon.com" }
      ]
    };
  },
  methods: {
     login() {
      this.loading = true;
      this.$cookie.delete('gsid');
      let data = Object.assign({}, this.formObject, {
        alliance: this.alliance
      });
      this.$store.dispatch(LOGIN2, data).finally(() => {
        this.loading = false;
      });
    }
  },
  mounted() {
    this.$refs.username.focus();
  }
};
</script>
